<div *ngIf="style === 'dots'" class="progress-dots"><div></div><div></div><div></div><div></div></div>
<div *ngIf="style === 'line'" class="progress-line"></div>
<div *ngIf="style === 'circle'" class="progress-circle"></div>
<div *ngIf="style === 'chase'" class="progress-chase"><div></div><div></div><div></div><div></div><div></div><div></div></div>
